import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from 'src/app/services/communication.service';

@Component({
  selector: 'app-link-coax',
  templateUrl: './link-coax.component.html',
  styleUrls: ['./link-coax.component.scss']
})
export class LinkCoaxComponent implements OnInit, OnChanges {
@Input() partner;
  @Input() currentData;
  @Input() modal;

  @Output() onConnected = new EventEmitter();

  public busy = true;
  
  public apiKey: string = null;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private communicationService: CommunicationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.busy = false;
  }

  ngOnChanges(changes) {
    if (changes.currentData && changes.currentData.currentValue) {
      const data = changes.currentData.currentValue;
      this.apiKey = data.apiKey;
    }
  }

  isValid(){
    if(this.apiKey == null || this.apiKey.length <= 0)
    {
      return true;
    }

    return false;
  }

   connect() {
    this.communicationService.connectStaticAccount(this.partner.ID,
      {
        TextPlatformSystemId: 4,
        Coax: {
          ApiKey: this.apiKey
        }
      }
    ).subscribe(res => {
      this.onConnected.emit();
    });
  }

  update(){
    this.communicationService.saveData(this.partner.ID,
      {
        TextPlatformSystemId: 4,
        Coax: {
          ApiKey: this.apiKey
        }
      }
    ).subscribe(res => {

    });
  }

  done() {
    this.onConnected.emit();
  }
}
